




































































































import Component, { mixins } from 'vue-class-component';
import { AxiosResponse } from 'axios';
import ShowContainer from '@/common/mixin/ShowContainer';
import DetailRow from '@/common/component/DetailRow.vue';
// import FacilityShowContainer from "@/context/facility/containers/FacilityShowContainer.vue";
import ConfigurationShowContainer
  from '@/context/configuration/container/ConfigurationShowContainer.vue';
import ProgressSpinnerWrapper from '@/common/component/ProgressSpinnerWrapper.vue';
import { ModelApi } from '@/context/model/api/ModelApi';
import { AdvancedModelShow } from '@/context/model/model/AdvancedModelShow';
import { dataLoggerRouter } from '@/context/data_logger/router/DataLoggerRouter';
import TooltipIcon from '@/general/component/tooltip-icon/TooltipIcon.vue';

@Component({
  components: {
    ProgressSpinnerWrapper,
    ConfigurationShowContainer,
    // FacilityShowContainer,
    DetailRow,
    TooltipIcon
  }
})
export default class DataLoggerShowContainer extends mixins(ShowContainer) {
  model!: AdvancedModelShow;
  tab = null;

  async fetch(id: number): Promise<void> {
    const response: AxiosResponse = await ModelApi.instance().show(id);
    this.model = response?.data?.view;
  }

  goToDataLogger(id: number): void {
    const route: Record<string, unknown> = dataLoggerRouter.show(id);
    this.$router.push(route);
  }
}
